interface FieldProps {
  label: string;
  type: string;
  value: string;
  onChange: (value: string) => void;
  autoComplete?: string;
  minLength?: number;
  required?: boolean;
  placeholder?: string;
}

/** A labelled text input. Shared so the auth screens cannot drift apart. */
function Field({
  label,
  type,
  value,
  onChange,
  autoComplete,
  minLength,
  required,
  placeholder,
}: FieldProps) {
  const id = `field-${label.toLowerCase().replace(/\s+/g, '-')}`;

  return (
    <div>
      <label htmlFor={id} className="mb-1.5 block text-sm font-semibold">
        {label}
      </label>
      <input
        id={id}
        type={type}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        autoComplete={autoComplete}
        minLength={minLength}
        required={required}
        placeholder={placeholder}
        className="w-full rounded-xl border-2 border-ink bg-paper px-4 py-3 outline-none transition-shadow placeholder:text-ink/35 focus:shadow-pop-sm"
      />
    </div>
  );
}

export default Field;
